import Button from '@zenbusiness/zui/Button';
import { superstyled } from '@zenbusiness/zui/styles';

export const Root = superstyled({
  name: 'AppFooter',
  styles: {
    display: 'flex',
    alignItems: 'start',
    gap: '0.75rem',
    flexDirection: 'column',
    margin: '0 auto',
    maxWidth: '1440px',
    paddingBlock: '1.5rem',
    textAlign: 'justify'
  }
});

export const CookiePreferences = superstyled({
  name: 'CookiePreferences',
  tag: Button,
  propsAdded: {
    variant: 'text',
    color: 'info'
  },
  styles: ({ theme }) => ({
    margin: 0,
    padding: 0,
    cursor: 'pointer',
    textDecoration: 'underline',
    fontSize: theme.typography.xs.fontSize,
    fontWeight: theme.typography.fontWeightRegular,
    lineHeight: theme.typography.xs.lineHeight,
    '&:hover': {
      backgroundColor: 'transparent'
    },
    '& span': {
      margin: 0,
      marginLeft: theme.spacing(0.5)
    }
  })
});
